const x = {
  default: "0 2px 4px 0 #283c5d29",
  interactive: "0 0 16px 1px #283c5d29",
  hover: "0 0px 32px 3px #283c5d29"
};
export {
  x as BoxShadows
};
